import React from "react";
import "./header.css";

const header = () => {
  return (
    <>
      <div className="header-container">
        <div className="header-text">Wordplay</div>
      </div>
    </>
  );
};

export default header;
